import { executeReport, REPORT_TYPES } from '../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery(startTime, endTime) {
  return executeReport(REPORT_TYPES.LINE_REPORT, { startTime, endTime });
}
